import { ActionProps } from "digimaker-ui/ActionsRender";
import {
  Delete,
  Move,
  MultiUpload,
  SetPriority,
  SetToTop,
  CopyFilepath,
} from "digimaker-ui/actions";
import { ViewSettingsType } from "digimaker-ui";
import { UserRoles } from "digimaker-ui/view";
import React from "react";
import { ListSchoolImage } from "./components/ListSchoolImage";

export const leftConfig = [
  {
    name: "Sites",
    icon: "fa-desktop",
    path: "/main/3",
    menu: [
      {
        name: "Sites",
        type: "treemenu",
        contenttype: ["folder", "page"],
        icon: "fas fa-home",
        is_site: true,
        open: true,
        root: 3,
      },
      {
        name: "Shared",
        type: "treemenu",
        contenttype: ["folder"],
        icon: "fas fa-share-alt",
        open: false,
        root: 460,
      },
      {
        name: "Resources",
        type: "treemenu",
        contenttype: ["folder"],
        icon: "far fa-images",
        open: true,
        root: 9,
      },
    ],
  },
  {
    name: "Users",
    icon: "fa-users",
    path: "/main/4",
    menu: [
      {
        name: "Organizations",
        type: "treemenu",
        contenttype: ["usergroup"],
        icon: "fas fa-sitemap",
        root: 4,
      },
      {
        name: "Roles",
        icon: "fas fa-user-tag",
        path: "/main/7",
      },
    ],
  },
];

/* get list config based on parent and content type */
export const getListConfig = (_parent: any, contenttype: string) => {
  const commonSettings = {
    show_header: true,
    show_table_header: true,
    pagination: 10,
    sort: [],
    row_actions: [
      {
        link: "/edit/{_location_id}?from=/main/{_from_id}",
        name: "Edit",
        icon: "icon-edit",
      },
      Delete,
    ],
  };

  const listConfg = {
    folder: {
      ...commonSettings,
      sort_default: [["published", "desc"]],
      columns: [
        { header: "Name", field: "name" },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
    },
    page: {
      ...commonSettings,
      sort_default: [
        ["priority", "desc"],
        ["published", "desc"],
      ],
      columns: [
        { header: "ID", field: "id" },
        { header: "Name", field: "name" },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
      row_actions: [
        {
          link: "/fulledit/{_location_id}?from=/main/{_from_id}",
          name: "Full edit",
          icon: "icon-edit",
        },
        Delete,
        (actionProps: ActionProps) => <SetToTop {...actionProps} />,
      ],
    },
    block: {
      ...commonSettings,
      sort_default: [
        ["priority", "desc"],
        ["modified", "desc"],
      ],
      sort: {
        name: "asc",
        modified: "desc",
        priority: "desc",
        author_name: "asc",
      },
      row_actions: [
        ...commonSettings.row_actions,
        (actionProps: ActionProps) => <SetToTop {...actionProps} />,
      ],
      columns: [
        { header: "Title", field: "title" },
        { header: "Author", render: (content) => content.metadata.author_name },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
      pagination: 20,
    },
    article: {
      ...commonSettings,
      sort_default: [
        ["priority", "desc"],
        ["modified", "desc"],
      ],
      sort: {
        name: "asc",
        modified: "desc",
        priority: "desc",
        author_name: "asc",
      },
      row_actions: [
        ...commonSettings.row_actions,
        {
          link: "/fulledit/{_location_id}?from=/main/{_from_id}",
          name: "Full edit",
          icon: "icon-edit",
        },
        (actionProps: ActionProps) => <SetToTop {...actionProps} />,
      ],
      columns: [
        { header: "Title", field: "title" },
        { header: "Cover image", field: "coverimage" },
        { header: "Author", render: (content) => content.metadata.author_name },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
      pagination: 20,
    },
    image: {
      sort_default: [["id", "desc"]],
      sort: [],
      columns: ["name", "image", "author", "published", "modified"],
      block_fields: ["image", "name", "modified"],
      show_header: true,
      show_table_header: true,
      actions: [],
      viewmode: "block",
      row_actions: [
        {
          link: "/edit/{_contenttype_id}?from=/main/{_from_id}",
          name: "Edit",
          icon: "icon-edit",
        },
        Delete,
      ],
      pagination: 25,
      row_more: ["export"],
      blockview_columns: ["image", "name", "modified"],
    },
    file: {
      sort_default: [["published", "desc"]],
      sort: [],
      columns: [
        { header: "ID", field: "id" },
        {
          header: "Title",
          render: (content) => (
            <a href={"/var/" + content.path} target="_blank">
              {content.title}
            </a>
          ),
        },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
      show_header: true,
      show_table_header: true,
      actions: [],
      row_actions: [
        CopyFilepath,
        {
          link: "/edit/{_contenttype_id}?from=/main/{_from_id}",
          name: "Edit",
          icon: "icon-edit",
        },
        Delete,
      ],
      pagination: 10,
      row_more: [],
    },
    usergroup: {
      ...commonSettings,
      sort_default: [["published", "desc"]],
      sort: [],
      columns: [
        { header: "Title", field: "title" },
        { header: "Author", render: (content) => content.metadata.author_name },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
    },
    user: {
      ...commonSettings,
      sort_default: [["name", "asc"]],
      sort: { name: "asc", modified: "desc" },
      columns: [
        { header: "Name", render: (content) => content.metadata.name },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
      pagination: 25,
    },
    role: {
      ...commonSettings,
      sort_default: [["name", "asc"]],
      columns: [{ header: "Name", render: (content) => content.metadata.name }],
      row_actions: [
        { link: "/main/role/{cid}", name: "Detail", icon: "fa-arrow-right" },
        {
          link: "/edit/role/{cid}?from=/main/7",
          icon: "fas fa-edit",
          name: "Edit",
        },
      ],
      pagination: 10,
    },
  };

  return listConfg[contenttype] ? listConfg[contenttype] : commonSettings;
};

/** get main config based on content */
export const getMainConfig = (content: any) => {
  const mainConfig = {
    folder: {
      actions: [(actionProps: ActionProps) => <SetPriority {...actionProps} />],
    },
    frontpage: {
      list: ["frontpage_block"],
    },
    page: {
      list: ["page", "folder"],
      new: ["page", "folder"],
      actions: [
        {
          link: "/fulledit/{_location_id}",
          name: "Full edit",
          icon: "icon-edit",
          title: "Edit the content",
        },
      ],
    },
    role: {
      view: true,
    },
    article: {
      view: true,
      metainfo: true,
      actions: [(actionProps: ActionProps) => <Move {...actionProps} />],
    },
    user: {
      view: true,
      viewComponent: UserRoles,
    },
  };

  let commonActions = [
    {
      link: "/edit/{_location_id}",
      name: "Edit",
      icon: "icon-edit",
      title: "Edit the content",
    },
    Delete,
  ];

  const commonMain = { list: [], new: [] };
  let result = { ...commonMain, ...mainConfig[content.metadata.contenttype] };
  if (result["actions"]) {
    result["actions"] = [...commonActions, ...result["actions"]];
  }

  let list = [] as string[];
  if (content.metadata.contenttype === "folder") {
    if (content.location.id == 3) {
      list = ["block", "page"];
    } else {
      if (content.children_type) {
        const childrenType = content.children_type.value;
        list.push(childrenType);
        if (childrenType === "school_image") {
          result["viewComponent"] = ListSchoolImage;
          list = [];
        }
      }
      let ids = content.location.hierarchy.split("/");
      if (ids.includes("10") || ids.includes("461")) {
        list = [...list, "image"];
        result["actions"] = [
          ...result["actions"],
          {
            link: "/image/multiupload/{_location_id}",
            name: "Multi upload",
            icon: "fas fa-image",
            title: "Multi upload",
          },
        ];
      }

      if (ids.includes("4")) {
        list = [...list, "user"];
      }

      if (ids.includes("7")) {
        list = [...list, "role"];
      }
    }

    result["list"] = list;
    result["new"] = ["folder", ...list];
  }
  return result;
};

export const getBrowseConfig = () => {
  return {
    filter: {
      "*": { contenttype: ["folder"] },
      usergroup: { contenttype: ["usergroup"] },
      user: { contenttype: ["folder"] },
      sv_product: { contenttype: ["sv_product_package"] },
    },
    list: {
      "*": {
        level: 1,
        can_select: false,
        pagination: 10,
        sort_default: [
          ["priority", "desc"],
          ["name", "asc"],
        ],
        sort: { priority: "desc", name: "asc", modified: "desc", id: "desc" },
        actions: [],
        columns: ["id", "title", "modified", "priority"],
      },
      image: {
        viewmode: "block",
        parent: 461,
        sort_default: [["modified", "desc"], "-"],
        block_fields: ["image", "name"],
      },
      school_image: {
        viewmode: "block",
        parent: 461,
        sort_default: [["modified", "desc"], "-"],
        block_fields: ["image", "name"],
      },
      user: {
        sort_default: [["modified", "desc"], "-"],
        parent: 4,
      },
    },
  };
};

export const getViewSettings = (contenttype: string) => {
  if (contenttype === "image" || contenttype === "school_image") {
    return {
      inline_fields: ["image"],
      block_fields: ["name", "image"],
      browselist: {
        viewmode: "block",
        columns: ["name"],
        sort_default: [["published", "desc"]],
      },
    } as ViewSettingsType;
  } else {
    return {
      inline_fields: ["title"],
      browselist: {
        viewmode: "list",
        columns: ["name", "published"],
        sort_default: [["name", "desc"]],
        pagination: 2,
      },
    } as ViewSettingsType;
  }
};
